import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import {FormControl, InputLabel, Input, FormHelperText, Alert, Divider} from '@mui/material';
import WebService from '@util/webService'
import {copyProperties, encodeParams, getAction, getNow, printVariable} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';

// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool, searchCompany } from '@util/helper';
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined"
import moment from 'moment';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import DialogTitle from "@mui/material/DialogTitle";
import ConfirmDialog from "@components/ConfirmDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import useAlert from "@hooks/useAlert";
import { MAX_FILE_SIZE } from '@util/constant';

const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileCompanySchoolPart = ({record, dialogHandler, companyList, callback}) => {
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'

  const defRecord = {}
  defRecord.schoolList = []  
  defRecord.schoolRltnList = []
  defRecord.companyRltnList = []
  
  const defTerms = {}
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [terms, _set_terms] = useState(defTerms)
  const [companies, set_companies] = useState([])
  const [companySchoolRltnList, set_companySchoolRltnList] = useState([])
  const [targetSchools, set_targetSchools] = useState([])
  const [targetList, set_targetList] = useState([])
  const [activeCompany, set_activeCompany] = useState(null)
  const [word, set_word] = useState('')
  const [files, set_files] = useState([])
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const {alert, renderAlert} = useAlert()
  const validate = () => {}
  
  const [schoolList, set_schoolList] = useState([])
  const [school, set_school] = useState({})
  
  const navigate = useNavigate()
  const searchButtonRef = useRef(null)
  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {
      dialogHandler[1](false)
      if(callback) {
        callback()
      }
    }
  }


  useEffect(() => {
    onLoad()
  }, [])

  const onLoad = async() => {
    openIndicator()
    closeIndicator()
  }
  
  const onSubmit = async () => {
    
    if(!activeCompany) {
      alert('회사가 선택되지 않았습니다.')
      return
    }
    if(!school.id) {
      alert('학교가 선택되지 않았습니다.')
      return
    }

    if(files.length === 0) {
      alert('관련자료가 첨부되지 않았습니다.')
      return
    }

    // const data = []
    const companySchoolRltn = {companyId: activeCompany.id, schoolId: school.id, rltnCode:'S001', statCode:'S001', regTime:getNow()}
    const data = {
      companySchoolRltn: JSON.stringify(companySchoolRltn)
    }
    const jsonData = JSON.stringify(data)
    const formData = new FormData()
    files.forEach((file, index) => {
      if (file instanceof File) {
        // formData.append(`files`, file)
        const f = new File([file], file.name, { type: file.type }) 
        formData.append(`files`, f)
      }
    })
    formData.append("body", new Blob([jsonData], { type: "application/json" }))
    const url = '/rltn/company/school/request'

    openIndicator()
    const resp = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    closeIndicator()

    if(resp.data.repCode !== 'ack') {
      alert(resp.data.repMessage)
      return
    }

    alert('신청되었습니다.', () => handleClose())

  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      searchButtonRef.current.click();
    }
  };
  const onSearch = async () => {
    const schools = await searchSchool(word)
    const schoolIdList = schools.map(r => r.id)
    console.log('schools=>', schools)
    set_schoolList(schools)
  }

  const onChangeFile = (e) => {
    const files = Array.from(e.target.files)
    for(const file of files) {
      // TODO
      if(file.size > MAX_FILE_SIZE * 10) {
        alert('파일 크기는 10MB 이하만 가능합니다.') 
        return
      }
    }
    set_files(files)
  }


  const [
    activeRow,
    errors,
    formLoading,
    handleChange,
    handleSubmit, 
   ] = useForm({
    initialValues: {...account, schoolRltnList:[], companyRltnList:[]}, 
    onSubmit: onSubmit,
    validate: validate,
  });

  const filterOptions = (options, state) => {
    let newOptions = []
    newOptions = options.filter(o => o.name.includes(state.inputValue)).slice(0, 100)
    return newOptions;
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

   return (
     <Fragment>
       <Dialog record={record} open={dialogHandler[0]} onClose={handleClose} maxWidth='sm' fullWidth>
         <DialogTitle>
           <Typography variant='h5' align='center'>
             위탁 대상 학교 신청
           </Typography>
           <Divider></Divider>
         </DialogTitle>
         <DialogContent sx={{minHeight:300}}>
           <br/>
           <Grid container spacing={2} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
             <Grid item xs={12} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
               <Autocomplete
                 disablePortal
                 fullWidth
                 options={companyList}
                 onInputChange={async (event, value, reason) => {
                   if(reason === 'input') {
                   }
                 }}
                 onChange = {async (e, v)=> {
                   set_activeCompany(v)
                 }}

                 size='small'
                 getOptionLabel={(option) => option.name}
                 renderInput={(params) => <TextField  {...params} label="회사선택" />}
               />
             </Grid>
             <Grid item xs={8} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
               <TextField
                 fullWidth
                 value={word}
                 label='학교명'
                 onChange={(e) => set_word(e.target.value.trim())}
               />
             </Grid>
             <Grid item xs={4} sx={{display:'flex', alignItems:'flex-end', justifyContent:'end'}}>
               <Button ref={searchButtonRef} onClick={onSearch}>검색</Button>
             </Grid>
           </Grid>
           <br/>
           <Grid container spacing={2}>
             <Grid item xs={12}>
               <MUITable>
                 <TableHead>
                   <TableRow>
                     <TableCell>선택</TableCell>
                     <TableCell>학교</TableCell>
                   </TableRow>
                 </TableHead>
                 <TableBody>
                   {
                     schoolList.map((row, index) => (
                       <TableRow key={index} onClick={() => {set_school(row)}}>
                         <TableCell>
                           <input
                             type='radio'
                             name='school'
                             checked={row.id === school.id}
                             value = {school.id}
                             onChange={(e) => {
                             }}
                           />

                         </TableCell>
                         <TableCell>
                           {row.label}
                         </TableCell>
                       </TableRow>
                     ))
                   }
                 </TableBody>
               </MUITable>
             </Grid>
           </Grid>
           <br/>
           <Grid container spacing={2}>
           <Grid item xs={12}>
             <Typography variant='h6' align='center'>첨부 서류</Typography>
             <Divider />
           </Grid>
            <Grid item xs={9} sx={{display:'flex', flexDirection:'column', alignItems:'center'}}>
              {
                files.map(file => (
                  <Typography variant='body2'>{file.name}</Typography>
                ))
              }
            </Grid>
            <Grid item xs={3}>
              <TextField
                variant="standard"          
                type="text"
                value={null}
                fullWidth

                label ="계약서 등 관련 자료"
                InputLabelProps={{shrink: files}}
                InputProps={{
                  endAdornment: (
                    <IconButton component="label">
                      <AttachFileOutlinedIcon />
                      <input
                        styles={{display:"none"}}
                        type="file"
                        accept='.jpg, .png, .pdf, .doc, .ppt' 
                        hidden
                        onChange={(e) => onChangeFile(e)}
                        multiple
                      />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
           </Grid>
         </DialogContent>

         <DialogActions>
           <Button onClick={handleClose}>
             닫기
           </Button>
           {/*<Button  onClick={onSubmit} >신청</Button>*/}
           <ConfirmDialog
             btn={<Button  color={'primary'}>신청</Button>}
             title={'알림'}
             content={'해당 학교 위탁 대상학교로 신청하시겠습니까?'}
             bc={'primary'}
             preHandle={() => {
               onSubmit()
             }}
             perform={() => {

             }}
           />
         </DialogActions>
       </Dialog>
       {renderSnackbar()}
       {renderIndicator()}
       {renderAlert()}
     </Fragment>
  );
}

export default ProfileCompanySchoolPart
